export enum ENotificationType {
  success = 'success',
  info = 'info',
  warning = 'warning',
  error = 'error',
}

export type TNotificationType = keyof typeof ENotificationType;

export type TNotification = {
  id: string;
  createdAt: number;
  title?: string;
  message?: React.ReactNode;
  messageKey?: string;
  messageArgs?: Record<string, string | number>;
  lifeDuration?: number;
  type?: TNotificationType;
};
